import {
    abtest_ProductListPricingAreaVariants
} from '../../list-page/interfaces/interfaces';
import {sendGAEvent} from '../../../domain/marketing/gtm-provider';
import {ProductsRelDocs} from "../product-page/interfaces";
import {getABTest, sendABTestAnalytics} from "../../../domain/abtest/abtest-provider";

interface IProductSubscribeButtonABTEST {
    product: ProductsRelDocs,
    className?: string,
    productListPricingAreaVariants:abtest_ProductListPricingAreaVariants;
    returnFunc?: Function,
}

const ProductSubscribeButtonABTEST = (props: IProductSubscribeButtonABTEST) => {

    const { product } = props;
    return (
        <>


            {/*Subscribe button POPUP*/
                props?.product.includedInSBS > 0 &&
                <div className={`mt-4 ml-4 dv-product-page-subscribe`}>

                    <button type="button" className={`${props?.productListPricingAreaVariants !== abtest_ProductListPricingAreaVariants.old ? "w-btn bg-yellow-400 text-gray-700" : "w-btn-outline-white"} w-40 lg:w-48`} data-skunumber={ product.skuNumber }
                       onClick={ evt => {
                           sendGAEvent('Subscribe','Subscribe Button');

                           if (props?.returnFunc) {
                               props?.returnFunc();
                           }
                       }}
                    >Subscribe</button>
                </div>
            }
        </>
    )
};

export default ProductSubscribeButtonABTEST;